import { MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import { SeveritySelectComponent, SeveritySelectInnerContainer, SeveritySelectComponentForm, StyledSeveritySelect } from "./severitySelect.styled";

interface SeveritySelectInterface {
    setFilterData: any
}

export default function SeveritySelect({setFilterData}: SeveritySelectInterface) {
    const severityLevels = ["Critical", "High", "Medium", "Low", "Informative", "Unclassified"]
    const [value, setValue] = useState('');

    useEffect(() => {
        if (value !== "") {
            setFilterData({filter: {"selectedSeverity": value}});
        }
    }, [value])
    
    return(
        <StyledSeveritySelect>
            <SeveritySelectInnerContainer>
                <p>Severity:</p>
                <SeveritySelectComponentForm>
                    <SeveritySelectComponent
                        labelId="select-severity"
                        id="select-severity"
                        value={value}
                        onChange={(event) => setValue(event.target.value as string)}
                        >
                        {severityLevels.map((level) => (
                            <MenuItem key={level} value={level}>
                            {level}
                            </MenuItem>
                        ))}
                    </SeveritySelectComponent>
                </SeveritySelectComponentForm>
            </SeveritySelectInnerContainer>
        </StyledSeveritySelect>
    )
}

